/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { UpdateScheduledDateComponent } from 'app/modules/jobs/job-details/edit-job-schedule/edit-job-schedule.component';
import * as moment from 'moment';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import _ from 'lodash';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { Subject, Subscription } from 'rxjs';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { debounceTime, pairwise, takeUntil } from 'rxjs/operators';
import { MetaData } from 'ng-event-bus/lib/meta-data';
import { ActivatedRoute } from '@angular/router';
import tippy from 'tippy.js';
import { NgxTippyProps } from 'ngx-tippy-wrapper';
import { ZuperSdkEventService } from 'app/core/services/sdk_service/sdk-event.service';
@Component({
  selector: 'app-reschedule-job',
  templateUrl: './reschedule-job.component.html',
  styleUrls: ['./reschedule-job.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RescheduleJobComponent implements OnInit, OnDestroy {

  @ViewChild('userInfoContent', { static: false }) userInfoContentRef!: TemplateRef<any>;

  rescheduleJobForm: UntypedFormGroup;
  jobDetails: any;
  mockedJobDetails: any;
  userDetails: any;
  isMultiTechAssignmentEnabled: boolean = false;
  customUserDetails: any;
  teamUid: any;
  allTeamUsers: any[];
  dropDateTime: any;
  timeOffUsers: any[];
  jobOverlapUsers: any[];
  timeFormat: string;
  dateFormat: string = 'DD/MM/YYYY';
  holidayName: string;
  holidayDate: string;
  dueDate: any;
  type: 'SCHEDULE' | 'RESCHEDULE';
  routeJobAssignmentType: 'RESCHEUDLE' | 'REASSIGN' = 'RESCHEUDLE';
  dialogTitle: any;
  showWarnings: boolean = false;
  warningsList: any;
  validatingOverlapsAndTimeoff: boolean = false;
  isOperationInProgress: boolean = false;
  unAssignUser: boolean = false;
  unAssignUserUid: any = null;
  teamName: string = '';
  unAssignUserTeamUid: any = null;
  blockJobsOnHoliday: boolean = false;
  blockHolidayName: string;
  routeDetails: any;
  droppedRouteDetails: any;
  disableUpdateBtn: boolean = false;
  checkRouteJobConflict: boolean =  false;
  checkRouteDurationExceed: boolean = false;
  jobAlreadyInAnotherRoute = {show: false, msg: '', routeDetails: null};
  showClearScheduleAlert: boolean = false;
  enableClearSchedule: boolean = false;
  isHoliday: boolean;
  manageUserAssignment = { defaultUsers: [], usersToAdd: [], usersToRemove: [], allUsers: [], selectedUsers: [], teamDetails: null, showAllTeamUsers: false }
  userInfoData = { instanceRef: null, contentRef: null, isOpened: false, userDetails: null, activeTab: 'skills', skillStartDate: null, skillEndDate: null };
  allShiftDetails: Map<string, any[]> = new Map<string, any[]>();
  unSubscription$: Subject<void> = new Subject<void>();
  userInfoTippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    hideOnClick: true,
    placement: 'right',
    arrow: true,
    zIndex: 1000,
    onShow: (instance: any) => {
      this.userInfoData.instanceRef = instance;
    }
  };
  getWarningMsg = _.debounce((): void => {
    const [startDateTime, endDateTime] = this.getStartAndEndTime();
    this.warningsList = this._dispatchBoardService.getScheduleWarningMsg('job', this.mockedJobDetails, this.userDetails, startDateTime, endDateTime, this.customUserDetails, true, false, { routeDetails: this.droppedRouteDetails, checkRouteJobConflict: this.checkRouteJobConflict, checkRouteDurationExceed: this.checkRouteDurationExceed });
    [this.isHoliday, this.blockHolidayName, this.blockJobsOnHoliday] = this._dispatchBoardService.isConflictWithHolidays(startDateTime, endDateTime);
    this.disableUpdateBtn = this.blockJobsOnHoliday || this.warningsList?.routeDurationExceedWarning?.show;
  }, 350, {leading: true, trailing: true});
  dateValidationRanges = {
    'minStartDate': null,
    'maxStartDate': null,
    'minEndDate': null,
    'maxEndDate': null
  };
  controlNameMappingForSDK = {
    'start_date': 'startDate',
    'end_date': 'endDate'
  };
  currentPage: string | null;
  SDKSubs$: Subscription[];

  constructor(
    private _localisationService: LocalisationService,
    public dialogRef: MatDialogRef<UpdateScheduledDateComponent>,
    public _utilityService: UtilityService,
    private formBuilder: UntypedFormBuilder,
    private _dispatchBoardService: DispatchBoardService,
    private _dataCollectorService: DataCollectorService,
    private _zuperDialogService: ZuperDialogService,
    private changeDetectorRef: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _sdkEventService: ZuperSdkEventService,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  ngOnInit(): void {
    const browserTimezone: string = moment.tz.guess();
    this._localisationService.setDefaultLanguage();
    this.dateFormat = this._utilityService.dateFormat;
    this.timeFormat = this._utilityService.timeFormat;
    this.jobDetails = this.dialogData.data?.jobDetails;
    this.mockedJobDetails  = {...this.jobDetails};
    this.userDetails = this.dialogData.data?.userDetails;
    this.teamUid = this.dialogData.data?.teamUid;
    this.allTeamUsers = this.dialogData.data?.allTeamUsers;
    this.customUserDetails = this.dialogData.data?.customUserDetails;
    this.isMultiTechAssignmentEnabled = this.dialogData.data?.isMultiTechAssignmentEnabled ?? false;
    this.unAssignUser = this.dialogData.data?.unAssignUser ?? false;
    this.unAssignUserUid = this.dialogData.data?.unAssignUserUid || null;
    this.teamName = this.dialogData.data?.teamName || null;
    this.unAssignUserTeamUid = this.dialogData.data?.unAssignUserTeamUid || null;
    this.dropDateTime = moment.utc(this.dialogData.data?.dropDateTime).tz(browserTimezone);
    this.routeDetails = this.dialogData.data?.routeDetails || null;
    this.droppedRouteDetails = this.dialogData.data?.targetRouteDetails || null;
    this.checkRouteJobConflict =  this.dialogData.data?.checkRouteJobConflict ?? false;
    this.checkRouteDurationExceed = this.dialogData.data?.checkRouteDurationExceed ?? false;;
    this.enableClearSchedule = this.dialogData.data?.enableClearSchedule ?? false;
    this.currentPage = this._utilityService.collectRouteData(this._route.snapshot)['page'];
    this.initiateRescheduleJobForm();
    this.initiateHandlersForSDK();
    if (this.isMultiTechAssignmentEnabled) {
      this.initializeUserAssignmentSettings();
    }
  }

  ngOnDestroy(): void {
    this.cleanUp();
    this.cleanUserInfoTippyContent();
    if (this.SDKSubs$) {
      this.SDKSubs$.forEach((sub$: Subscription) => sub$.unsubscribe());
      this._utilityService.castModalEventToSdk('close', {
        id: 'job_reschedule',
      });
    }
  }

  initializeUserAssignmentSettings(): void {
    // Initialize removed users
    const unassignedUserDetails = this.getUserDetails(this.unAssignUserUid) || {}
    this.manageUserAssignment.usersToRemove = this.unAssignUserUid ?
      [{
        ...unassignedUserDetails,
        skillDetails: this.getUserSkillsDetails(unassignedUserDetails),
        showCheckbox: false,
        isSelected: false,
        type: 'unassign',
        team: { team_name: this.teamName, team_uid: this.teamUid }
      }] : [];

    // Initialize added users
    this.manageUserAssignment.usersToAdd = this.userDetails ?
      [{
        ...this.userDetails,
        skillDetails: this.getUserSkillsDetails(this.userDetails),
        showCheckbox: false,
        isSelected: false,
        type: 'assign',
        hasValidProfilePicture: this._utilityService.hasValidProfilePicture(this.userDetails?.imageUrl),
        team: { team_name: this.teamName, team_uid: this.teamUid }
      }] : [];

    const removeUserIds = new Set(this.manageUserAssignment.usersToRemove.map(user => user?.user_uid));
    const addUserIds = new Set(this.manageUserAssignment.usersToAdd.map(user => user?.user_uid));

    this.manageUserAssignment.defaultUsers = [
      ...this.manageUserAssignment.usersToRemove.filter(user => !addUserIds.has(user.user_uid)),
      ...this.manageUserAssignment.usersToAdd
    ];

    this.manageUserAssignment.allUsers = this.allTeamUsers
      .filter(user => !removeUserIds.has(user.user_uid) && !addUserIds.has(user.user_uid))
      .map(user => {
        const assignedUser = this.isUserAlreadyAssigned(user?.user_uid);
        if (assignedUser?.team) {
          user['anotherTeam'] = assignedUser?.team;
        }
        return {
          ...user,
          showCheckbox: true,
          isSelected: false,
          type: 'assign',
          hasValidProfilePicture: this._utilityService.hasValidProfilePicture(user?.imageUrl),
          skillDetails: this.getUserSkillsDetails(user, this.jobDetails),
          team: { team_name: this.teamName, team_uid: this.teamUid }
        };
      }).sort((a: any, b: any) => {
        const skillCountA = a?.skillDetails?.validSkillCount || 0;
        const skillCountB = b?.skillDetails?.validSkillCount || 0;
        if (skillCountA === 0 && skillCountB === 0) {
          return a?.first_name.localeCompare(b?.first_name);
        }
        return skillCountB - skillCountA;
      });
  }

  onSelectedUserUpdated(): void {
    this.manageUserAssignment.selectedUsers = this.manageUserAssignment.allUsers.filter((user: any) => user?.isSelected && !user?.anotherTeam);
    this.mockedJobDetails['assigned_to'] = [...this.jobDetails['assigned_to'], ...this.manageUserAssignment.selectedUsers.map((user: any) => {
      return {
        user: user,
        team: { team_name: this.teamName, team_uid: this.teamUid }
      };
    })];
    this.getWarningMsg();
  }

  getUserDetails(userUid: string): any {
    if (!userUid || !this.allTeamUsers) { return null; }
    const userDetails = this.allTeamUsers.find((user: any) => user?.user?.user_uid === userUid || user?.user_uid === userUid);
    userDetails['hasValidProfilePicture'] = this._utilityService.hasValidProfilePicture(userDetails?.imageUrl);
    return userDetails ?? null;
  }

  isUserAlreadyAssigned(userUid: string, jobDetails: any = this.jobDetails): any {
    if (!userUid || !jobDetails?.assigned_to) {
      return null;
    }
    return jobDetails.assigned_to.find((assignee: any) => assignee?.user?.user_uid === userUid) || null;
  }

  showAllTeamUsers(): void {
    this.manageUserAssignment.showAllTeamUsers = true;
  }

  selectAllUsers(): void {
    this.manageUserAssignment.allUsers.forEach((user: any) => {
      if (!user?.anotherTeam) {
        user.isSelected = true;
      }
    });
    this.onSelectedUserUpdated();
  }

  unSelectAllUsers(): void {
    this.manageUserAssignment.allUsers.forEach((user: any) => {
      user.isSelected = false;
    });
    this.onSelectedUserUpdated();
  }

  getShiftDetailsOnDateChange(): void {
    const startDate = this.rescheduleJobForm.controls.startDate.value.format('YYYY-MM-DD') + ' 00:00:00';
    const endDate = this.rescheduleJobForm.controls.endDate.value.format('YYYY-MM-DD') + ' 23:59:59';
    const startDateMoment = moment(startDate, 'YYYY-MM-DD HH:mm:ss');
    const endDateMoment = moment(endDate, 'YYYY-MM-DD HH:mm:ss');
    const dateDiff = endDateMoment.diff(startDateMoment, 'days');

    if (dateDiff <= 2) {
      if ( !this.userInfoData.skillStartDate || !this.userInfoData.skillEndDate || !startDateMoment.isSame(this.userInfoData.skillStartDate, 'day') 
        || !endDateMoment.isSame(this.userInfoData.skillEndDate, 'day') ) {
        this.userInfoData.skillStartDate = startDateMoment;
        this.userInfoData.skillEndDate = endDateMoment;
        this.getTeamShiftDetails(startDate, endDate);
      }
    }
    else {
      this.allShiftDetails.clear();
      this.userInfoData.skillStartDate = null;
      this.userInfoData.skillEndDate = null;
      this.manageUserAssignment.usersToRemove = this.manageUserAssignment.usersToRemove.map((user: any) => {
        user.shiftDetails = null;
        return user;
      });
      this.manageUserAssignment.usersToAdd = this.manageUserAssignment.usersToAdd.map((user: any) => {
        user.shiftDetails = null;
        return user;
      });
      this.manageUserAssignment.allUsers = this.manageUserAssignment.allUsers.map((user: any) => {
        user.shiftDetails = null;
        return user;
      });
    }
  }

  getTeamShiftDetails(startDate: string, endDate: string): void {
    this.allShiftDetails.clear();
    this._dispatchBoardService.getUserShiftDetails(this.teamUid, startDate, endDate).pipe(takeUntil(this.unSubscription$)).subscribe((response: any) => {
      const allShiftDetails: any[] = response?.data || [];
      allShiftDetails.forEach((shift: any) => {
        const userUid: string = shift?.user_details?.user_uid;
        const shiftDetails: any = {};
        shiftDetails.shiftId = shift?.shift_uid;
        shiftDetails.shiftName = shift?.shift_label;
        shiftDetails.start_date_time = shift?.start_date_time;
        shiftDetails.end_date_time = shift?.end_date_time;
        [shiftDetails['startDateTime'], shiftDetails['endDateTime']] = this._dispatchBoardService.getStartEndTime(shift?.start_date_time, shift?.end_date_time, true);
        if (this.allShiftDetails.get(userUid)) {
          this.allShiftDetails.get(userUid).push(shiftDetails);
        } else if (userUid) {
          this.allShiftDetails.set(userUid, [shiftDetails]);
        }
      });
      this.updateShiftDetails();
    });
  }

  updateShiftDetails(): void {
    this.manageUserAssignment.usersToRemove = this.manageUserAssignment.usersToRemove.map((user: any) => {
      const userShiftDetails = this.allShiftDetails.get(user?.user_uid) || [];
      user.shiftDetails = userShiftDetails ? userShiftDetails.sort((a: any, b: any) => {
        const startA = moment(a?.start_date_time);
        const startB = moment(b?.start_date_time);
        return startA.isValid() && startB.isValid() ? startA.diff(startB) : 0;
      }) : [];
      return user;
    });

    this.manageUserAssignment.usersToAdd = this.manageUserAssignment.usersToAdd.map((user: any) => {
      const userShiftDetails = this.allShiftDetails.get(user?.user_uid) || [];
      user.shiftDetails = userShiftDetails.sort((a: any, b: any) => {
        const startA = moment(a?.start_date_time);
        const startB = moment(b?.start_date_time);
        return startA.isValid() && startB.isValid() ? startA.diff(startB) : 0;
      });
      return user;
    });

    this.manageUserAssignment.allUsers = this.manageUserAssignment.allUsers.map((user: any) => {
      const userShiftDetails = this.allShiftDetails.get(user?.user_uid) || [];
      user.shiftDetails = userShiftDetails.sort((a: any, b: any) => {
        const startA = moment(a?.start_date_time);
        const startB = moment(b?.start_date_time);
        return startA.isValid() && startB.isValid() ? startA.diff(startB) : 0;
      });
      return user;
    });
  }

  openUserInfo(event$: any, user: any): void {
    const buttonElement: HTMLElement = event$.currentTarget;
    if (buttonElement) {
      this.userInfoData.instanceRef = tippy(buttonElement, {
        ...this.userInfoTippyProps,
        content: this.getUserInfoTemplateContent(user),
        onHidden: (instance: any) => {
          this.ngZone.run(() => {
            user['infoOpend'] = false;
            this.userInfoData.activeTab = 'skills';
            this.changeDetectorRef.detectChanges();
          })
          this.cleanUserInfoTippyContent();
          if (!instance?.state?.isDestroyed) {
            instance.destroy();
          }
          this.userInfoData.instanceRef = null;
          if (this.userInfoData.contentRef) {
            this.userInfoData.contentRef.destroy();
            this.userInfoData.contentRef = null;
          }
        }
      });

      this.userInfoData.instanceRef.show();
      user['infoOpend'] = true;
      this.userInfoData.isOpened = true;
      this.userInfoData.userDetails = user;
    }
  }

  getUserInfoTemplateContent(user: any, updateTooltip: boolean = false): HTMLElement {
    if (!updateTooltip) {
      this.cleanUserInfoTippyContent();
    }
    const context = {
      user: user,
      activeTab: this.userInfoData.activeTab || 'skills',
      toggleTab: (tab: 'skills' | 'shifts') => {
        this.ngZone.run(() => {
          this.toggleUserInfoTab(tab);
          this.changeDetectorRef.detectChanges();
        });
      }
    };

    this.userInfoData.contentRef = this.userInfoContentRef.createEmbeddedView(context);
    this.userInfoData.contentRef.detectChanges();

    const div = document.createElement('div');
    this.userInfoData.contentRef.rootNodes.forEach((node: any) => div.appendChild(node));
    return div;
  }

  toggleUserInfoTab(tab: 'skills' | 'shifts'): void {
    if (this.userInfoData.activeTab === tab) {
      return;
    }
    this.userInfoData.activeTab = tab;
    this.changeDetectorRef.detectChanges();

    if (this.userInfoData.instanceRef && this.userInfoData.userDetails) {
      this.userInfoData.instanceRef.setContent(
        this.getUserInfoTemplateContent(this.userInfoData.userDetails, true)
      );
    }
  }
  
  cleanUp(): void {
    if (this.userInfoData.instanceRef) {
      this.userInfoData.instanceRef.hide();
      this.userInfoData.instanceRef.destroy();
      this.userInfoData.instanceRef = null;
    }
    this.unSubscription$.next();
    this.unSubscription$.complete();
  }


  cleanUserInfoTippyContent(): void {
    if (this.userInfoData.contentRef) {
      this.userInfoData.contentRef.destroy();
      this.userInfoData.contentRef = null;
    }

    if (this.userInfoData?.instanceRef) {
      this.userInfoData.instanceRef.destroy();
      this.userInfoData.instanceRef = null;
    }

    this.userInfoData.isOpened = false;
  }


  getUserSkillsDetails(userDetails: any, jobDetails: any = this.jobDetails): any {
    const userSkills = userDetails?.user_skills || [];
    const jobSkills = jobDetails?.skills || [];

    const skills = userSkills.map((userSkill: any) => {
      const skillUid = userSkill?.skillsets?.skillset_uid;
      const endDate = moment(userSkill?.end_date);
      return {
        ...userSkill,
        skillUid: skillUid,
        skill_level: userSkill?.skill_level > 100 ? 100 : userSkill?.skill_level < 0 ? 0 : userSkill?.skill_level, 
        skillName: userSkill?.skillsets?.skillset_name,
        isSkillApplicable: jobSkills.some((jobSkill: any) => jobSkill?.skill_uid === skillUid),
        isExpired: endDate.isBefore(moment()),
        isNearExpiration: endDate.isBetween(moment(), moment().add(14, 'days')),
        expiredOn: this._dispatchBoardService.formatDateTime(userSkill?.end_date, this.dateFormat),
      };
    });

    const matchedSkills = skills.filter((skill: any) => skill.isSkillApplicable && !skill.isExpired);
    const unmatchedSkills = skills.filter((skill: any) => !skill.isSkillApplicable || skill.isExpired);

    return {
      matchedSkills,
      unmatchedSkills,
      validSkillCount: matchedSkills.length,
      jobSkillCount: jobSkills?.length,
    };
  }

  initiateRescheduleJobForm(): void {
    const scheduledStartTime = this.jobDetails?.scheduled_start_time;
    const scheduledEndTime = this.jobDetails?.scheduled_end_time;
    this.type = this._utilityService.isEmptyOrUndefined(scheduledStartTime) ? 'SCHEDULE' : 'RESCHEDULE';
    this.dialogTitle = this.getDialogTitle(this.jobDetails);

    let estimatedDays: any; let estimatedHours: any; let estimatedMinutes: any;
    if (this.type === 'SCHEDULE') {
      estimatedDays = this.jobDetails?.job_category?.estimated_duration?.days ?? 0;
      estimatedHours = this.jobDetails?.job_category?.estimated_duration?.hours ?? 0;
      estimatedMinutes = this.jobDetails?.job_category?.estimated_duration?.minutes ?? 0;
      estimatedMinutes = estimatedDays === 0 && estimatedHours === 0 && estimatedMinutes === 0 ? 60 : estimatedMinutes;
    }
    else {
      estimatedDays = 0;
      estimatedHours = 0;
      estimatedMinutes = moment(scheduledEndTime).diff(scheduledStartTime, 'minutes');
    }

    let endTimePrefill = this.dropDateTime.clone().add(estimatedDays, 'day').add(estimatedHours, 'hour').add(estimatedMinutes, 'minute');
    if (this.dropDateTime.isSame(endTimePrefill)) {
      estimatedHours = 1;
      endTimePrefill = endTimePrefill.add(estimatedHours, 'hour');
    }
    const endDatePrefill = endTimePrefill;

    this.rescheduleJobForm = this.formBuilder.group({
      startDate: [this.dropDateTime, Validators.required],
      startTime: [this.dropDateTime.format(this.timeFormat), Validators.required],
      startTimePicker: [this.dropDateTime],
      endDate: [endDatePrefill, Validators.required],
      endTime: [endTimePrefill.format(this.timeFormat), [Validators.required, , endTimeMinValidator()]],
      endTimePicker: [endTimePrefill],
      reason: [''],
    });

    this.rescheduleJobForm.controls.startDate.valueChanges
      .pipe(takeUntil(this.unSubscription$))
      .subscribe((startDate: any) => {
        this.dateValidationRanges.minEndDate = startDate;
        const startTime = this.rescheduleJobForm.controls.startTimePicker.value;
        const startDateTime = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
        const endDateTime = startDateTime.add(estimatedDays, 'day').add(estimatedHours, 'hour').add(estimatedMinutes, 'minute');
        if (!this.rescheduleJobForm.controls.endDate.dirty) {
          this.rescheduleJobForm.controls.endDate.setValue(endDateTime);
        }
        if (this.isMultiTechAssignmentEnabled) {
          this.getShiftDetailsOnDateChange();
        }
      });

    this.rescheduleJobForm.controls.endDate.valueChanges
      .pipe(takeUntil(this.unSubscription$))
      .subscribe(() => {
        if (this.isMultiTechAssignmentEnabled) {
          this.getShiftDetailsOnDateChange();
        }
      });

    this.rescheduleJobForm.controls.startTimePicker.valueChanges
      .pipe(takeUntil(this.unSubscription$))
      .subscribe((startTime: any) => {
        this.rescheduleJobForm.controls.startTime.setValue(startTime.format(this.timeFormat));
        const startDate = this.rescheduleJobForm.controls.startDate.value;
        const startDateTime = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
        this.rescheduleJobForm.controls.startDate.setValue(startDateTime);
        const endDateTime = startDateTime.clone().add(estimatedDays, 'day').add(estimatedHours, 'hour').add(estimatedMinutes, 'minute');
        if (!this.rescheduleJobForm.controls.endDate.dirty) {
          this.rescheduleJobForm.controls.endDate.setValue(endDateTime);
        }
        this.rescheduleJobForm.controls.endTimePicker.setValue(endDateTime);
      });

    this.rescheduleJobForm.controls.endTimePicker.valueChanges
      .pipe(takeUntil(this.unSubscription$))
      .subscribe((endTime: any) => {
        this.rescheduleJobForm.controls.endTime.setValue(endTime.format(this.timeFormat));
        this.rescheduleJobForm.controls.endTime.updateValueAndValidity();
        const endDate = this.rescheduleJobForm.controls.endDate.value;
        const endDateTime = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
        this.rescheduleJobForm.controls.endDate.setValue(endDateTime);
        this.getWarningMsg();
      });
    this.jobAlreadyInAnotherRoute = { show: false, msg: '', routeDetails: null };
    if (this.checkRouteJobConflict && this.jobDetails?.route?.route_uid) {
      const isJobAlreadyInAnotherRoute = this.jobDetails?.route?.route_uid !== this.droppedRouteDetails?.route_uid;
      if (isJobAlreadyInAnotherRoute) {
        this.jobAlreadyInAnotherRoute.routeDetails = this.jobDetails?.route;
        this.jobAlreadyInAnotherRoute.show = true;
        this.jobAlreadyInAnotherRoute.msg = this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.remove_from_another_route') + ` '${this.jobDetails?.route?.route_name}'`;
      }
    }
    this.getWarningMsg();
  }

  isMeridian(): boolean {
    return this.timeFormat === 'hh:mm A';
  };

  getStartAndEndTime(applyTimezone: boolean = false): any[] {
    const startDate = this.rescheduleJobForm.controls.startDate.value;
    const startTime = this.rescheduleJobForm.controls.startTimePicker.value;
    const endDate = this.rescheduleJobForm.controls.endDate.value;
    const endTime = this.rescheduleJobForm.controls.endTimePicker.value;

    let startDateTime: any;
    let endDateTime: any;

    if (applyTimezone) {
      startDateTime = moment.tz(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
      endDateTime = moment.tz(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
    }
    else {
      startDateTime = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
      endDateTime = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
    }
    return [startDateTime, endDateTime];
  }

  getDialogTitle(jobDetails: any): string {
    const workOrderNumber = jobDetails?.work_order_number || '';
    const prefix = jobDetails?.prefix || '';
    const jobTitle = jobDetails?.job_title || '';
    return `${workOrderNumber !== '' ? '#' : ''}${prefix} ${workOrderNumber} ${jobTitle}`;
  }

  onDateChange(): void {
    this.getWarningMsg();
    this.rescheduleJobForm.get('endTime').markAsTouched();
    this.rescheduleJobForm.get('endTime').updateValueAndValidity();
  }

  rescheduleJob(): void {
    this.rescheduleJobForm.markAllAsTouched();
    this.cleanUp();
    if (!this.rescheduleJobForm.invalid) {
      const [startDateTime, endDateTime] = this.getStartAndEndTime(true);
      const scheduledStartTime = startDateTime.clone().utc().format('YYYY-MM-DD HH:mm:ss');
      const scheduledEndTime = endDateTime.clone().utc().format('YYYY-MM-DD HH:mm:ss');
      const reason = this.rescheduleJobForm.controls.reason.value;
      const jobUid = this.jobDetails?.job_uid;
      const userUid = this.userDetails?.user_uid;
      const teamUid = this.teamUid;
      const _this = this;
      let isJobDropedOnDiffRoute: boolean = false;
      let oldRouteUid: any;
      let newRouteUid: any;
      if(this.routeDetails && this.droppedRouteDetails) {
        oldRouteUid = this.routeDetails?.route_uid;
        newRouteUid = this.droppedRouteDetails?.route_uid;
        isJobDropedOnDiffRoute = oldRouteUid !== newRouteUid || this.jobAlreadyInAnotherRoute.show;
      }
      if(this.jobAlreadyInAnotherRoute.show) {
        oldRouteUid = this.jobAlreadyInAnotherRoute.routeDetails?.route_uid;
      }
      const _callbackDialogData = {
        jobUid: jobUid,
        userUid: userUid,
        teamUid: teamUid,
        scheduledStartTime: startDateTime,
        scheduledEndTime: endDateTime,
        skipAssignJobToRoute: this.jobAlreadyInAnotherRoute.show,
        additionalUserAssignment: this.manageUserAssignment.selectedUsers.map((user: any) => {
          return {
            user: user,
            team: { team_name: this.teamName, team_uid: this.teamUid }
          };
        })
      };
      let confirmationDialogInstance: any;
      let selectedUserPayload: any[] = [];

      //New Assignment
      if (this.manageUserAssignment.showAllTeamUsers) {
        selectedUserPayload = this.manageUserAssignment.allUsers.filter((user: any) => user?.isSelected && !user?.anotherTeam);
        selectedUserPayload = selectedUserPayload.map((user: any) => {
          return { userUid: user.user_uid, teamUid: user.team.team_uid, type: 'ASSIGN' };
        });
      }

      //Check for job overlaps
      let assignedTo: any[] = this.jobDetails?.assigned_to?.map((assignee: any) => _.get(assignee, ['user', 'user_uid']));
      assignedTo.push(userUid);

      //Selected users uid
      const selectedUserUids: any[] = this.manageUserAssignment.selectedUsers.map((user: any) => user?.user_uid);
      assignedTo = [...assignedTo, ...selectedUserUids];
      assignedTo = _.compact(_.uniq(assignedTo));
      
      this.validatingOverlapsAndTimeoff = true;
      const jobScheduleOverlapPayload = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        from_date: scheduledStartTime, to_date: scheduledEndTime, job_uid: jobUid, user_uid: assignedTo.join(',')
      };
      this.isOperationInProgress = true
      this._dataCollectorService.putData(this._dispatchBoardService.scheduleOverlapUrl, jobScheduleOverlapPayload)
      .pipe(takeUntil(this.unSubscription$))
        .subscribe(async (response: any) => {
          this.isOperationInProgress = false;
          const customUserDetails = this._dispatchBoardService.getCustomEmployeeDetailsRemote(response?.data);
          const warnings = this._dispatchBoardService.getScheduleWarningMsg('job', this.mockedJobDetails, this.userDetails, startDateTime, endDateTime, customUserDetails, false, true);
          const openConfirmationDialog = Object.values(warnings).filter((warning: any) => warning.show).length > 0;

          if (openConfirmationDialog) {
            confirmationDialogInstance = this._dispatchBoardService.scheduleConfirmationDialog('job',this.jobDetails, warnings);
            this.validatingOverlapsAndTimeoff = false;
            this.changeDetectorRef.markForCheck();
            confirmationDialogInstance?.afterClosed()
              .subscribe(async (result: boolean) => {
                if (result) {
                  this.validatingOverlapsAndTimeoff = true;
                  this.changeDetectorRef.markForCheck();
                  if(isJobDropedOnDiffRoute) {
                    await this.reassignRouteJobToAnotherRoute(oldRouteUid, newRouteUid, jobUid);
                  }
                  if(!this.jobAlreadyInAnotherRoute.show) {
                    this._dispatchBoardService.scheduleAndAssignJob(jobUid, scheduledStartTime, scheduledEndTime, this.type, reason, [{ userUid: userUid, teamUid: teamUid, type: 'ASSIGN' }, { userUid: this.unAssignUserUid, teamUid: this.unAssignUserTeamUid, type: 'UNASSIGN' }, ...selectedUserPayload], (status: boolean) => {
                      if (status) {
                        this.dialogRef.close(_callbackDialogData);
                        this.validatingOverlapsAndTimeoff = true;
                      }
                      else {
                        this.validatingOverlapsAndTimeoff = false;
                      }
                      this.changeDetectorRef.markForCheck();
                    });
                  }
                  else {
                    this.validatingOverlapsAndTimeoff = false;
                    this.dialogRef.close(_callbackDialogData);
                    this.changeDetectorRef.markForCheck();
                  } 
                }
              });
          } else {
            this.validatingOverlapsAndTimeoff = true;
            this.changeDetectorRef.markForCheck();
            if(isJobDropedOnDiffRoute) {
              await this.reassignRouteJobToAnotherRoute(oldRouteUid, newRouteUid, jobUid);
            }
            if (!this.jobAlreadyInAnotherRoute.show) {
              this.validatingOverlapsAndTimeoff = true;
              this._dispatchBoardService.scheduleAndAssignJob(jobUid, scheduledStartTime, scheduledEndTime, this.type, reason, [{ userUid: userUid, teamUid: teamUid, type: 'ASSIGN' }, { userUid: this.unAssignUserUid, teamUid: this.unAssignUserTeamUid, type: 'UNASSIGN' }, ...selectedUserPayload], (status: boolean) => {
                if (status) {
                  this.dialogRef.close(_callbackDialogData);
                  this.validatingOverlapsAndTimeoff = false;
                }
                else {
                  this.validatingOverlapsAndTimeoff = false;
                }
                this.changeDetectorRef.markForCheck();
              });
            }
            else {
              this.validatingOverlapsAndTimeoff = false;
              this.dialogRef.close(_callbackDialogData);
            }
          }
          this.changeDetectorRef.markForCheck();
        }, () => {
          this.isOperationInProgress = false;
          this.validatingOverlapsAndTimeoff = false;
      });
    }
  }

  reassignRouteJobToAnotherRoute(oldRouteUid: string, newRouteUid: string, jobUid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const param = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'assign_route_users': true, 'job_uid': jobUid, 'route_uid': newRouteUid
      };
      this._dispatchBoardService.reassignJobToAnotherRoute(oldRouteUid, param, false, (status: boolean) => {
        if (status) {
          resolve(true);
        }
        else {
          resolve(false);
        }
        this.changeDetectorRef.markForCheck();
      });
    });
  }

  getMessageWithNote(): string {
    const baseMessage = this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.message');
    if (this.jobDetails?.route) {
      return `${baseMessage} ?<br><p class="font-medium text-base mt-2 text-red-600">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.note')} '${this.jobDetails?.route?.route_name}'</p>`;
    }
    return `${baseMessage} ?`;
  }

  async clearSchedule(): Promise<void>{
    if(this._sdkEventService.checkForPreEventHandler('dispatch_board.job_clear_schedule')) {
      let canProceed = await this._sdkEventService.castPreEventListener('dispatch_board.job_clear_schedule', this.jobDetails);
      if(!canProceed) {
        return;
      }
    }
    if(!this.jobDetails?.due_date) {
      this.showClearScheduleAlert = true;
      return;
    }
   
    const updateJobScheduleConfirmationDialog = this._zuperDialogService.open({
      title: this._utilityService.getLocaleValue('text.clear_schedule'),
      type: 'error',
      message: this.getMessageWithNote(),
      actions: {
          confirm: {
              show: true,
              label: 'Clear Schedule',
              color: 'primary',
              confirmDisplayKey: 'text.clear_schedule'
          },
          cancel: {
              show: true,
              label: 'Cancel',
              cancelDisplayKey: 'cancel.text'
          }
      }
    });
    updateJobScheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        if(this.jobDetails?.route?.route_uid) {
          const removeJobParam = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            jobs: [{ job_uid: this.jobDetails?.job_uid }], unassign_users: false
          };
          const routeUid = this.jobDetails?.route?.route_uid;

          this._dataCollectorService.deleteDataPayload(`${this._dataCollectorService.baseurl()}/routes/${routeUid}/job`, removeJobParam)
          .pipe(takeUntil(this.unSubscription$))
          .subscribe((response: any) => {
              this.clearScheduleJob();
              this.changeDetectorRef.markForCheck();
          }, (error: any) => {
          });
        }
        else{
          this.clearScheduleJob();
          this.changeDetectorRef.markForCheck();
        }
      }
    });
  }

  clearScheduleJob(): void{
    const payload: any = {
      job: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        job_uid: this.jobDetails?.job_uid,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        due_date: moment(this.jobDetails?.due_date)?.endOf('day')?.utc()?.format('YYYY-MM-DD HH:mm:ss'),

      }
    };
    if(this.jobDetails?.job_timezone && this._utilityService.isTimeZoneEnabled === false){
      payload.job['job_timezone'] = null;
    }
    this._dataCollectorService.putData(`${this._dispatchBoardService?.jobDetailsUrl}?clear_schedule=true?`,payload)
    .pipe(takeUntil(this.unSubscription$))
    .subscribe((resposne: any)=>{
      this.dialogRef.close({type: 'clearSchedule'});
      this.changeDetectorRef.markForCheck();
    },(error: any)=>{
    });
  }

  //#region UI SDK

  initiateHandlersForSDK(): void{
    const formValueChangeForSDKEmit$ = this.rescheduleJobForm.valueChanges.pipe(debounceTime(1000), pairwise()).subscribe(([prev, next]: any[]) => {
      if (this.rescheduleJobForm.valid) {
        this._utilityService.castModalEventToSdk('change', {
          id: 'job_reschedule',
          old_value: this._utilityService.convertMomentFieldsToDate(prev),
          new_value: this._utilityService.convertMomentFieldsToDate(next),
        });
      }
    });
    const formPatchSub$ = this._utilityService.listenForFormPatchEvent(`${this.currentPage}.job_reschedule`).pipe().subscribe((res: MetaData) => {
      const controlName = this.controlNameMappingForSDK[res.data['controlName']];
      const control = this.rescheduleJobForm.controls[controlName];
      const timeControl = this.rescheduleJobForm.controls[controlName === 'startDate' ? 'startTime' : 'endTime'];
      const timePickerControl = this.rescheduleJobForm.controls[controlName === 'startDate' ? 'startTimePicker' : 'endTimePicker'];
      if(!control){
        return;
      }
      if (res.key.includes('prop')) {
        // patching configs of form control
        if (controlName && res.data['config'] && control) {
          const validations = res.data['config'];
          let pairKey = '';
          Object.keys(validations).forEach(((key: any) => {
            switch (key) {
              case 'min':
                pairKey = controlName === 'startDate' ? 'minStartDate' : 'minEndDate';
                this.dateValidationRanges[pairKey] = moment(validations[key]).isValid() ? moment(validations[key]) : null;
                if (control?.value < this.dateValidationRanges[pairKey]) {
                  control?.setValue(this.dateValidationRanges[pairKey]);
                }
                break;
              case 'max':
                pairKey = controlName === 'startDate' ? 'maxStartDate' : 'maxEndDate';
                this.dateValidationRanges[pairKey] = moment(validations[key]).isValid() ? moment(validations[key]) : null;
                if (control?.value > this.dateValidationRanges[pairKey]) {
                  control?.setValue(this.dateValidationRanges[pairKey]);
                }
                break;
              case 'disabled':
                if((validations[key] || false)){
                  control?.disable();
                  timeControl?.disable();
                  timePickerControl?.disable();
                }
                break;
            }
          }));
        };
      } else if (res.key.includes('set')) {
        //patching values of form
        if (controlName && res.data['value'] && control) {
          if (moment(control.value).isValid()) {
            const dateValue = moment(res.data['value']).isValid() ? moment(res.data['value']) : control.value;
            control.setValue(dateValue);
            timeControl.setValue(dateValue.format(this.timeFormat));
            timePickerControl.setValue(dateValue);
          } else {
            const value = res.data['value'];
            control.setValue(value);
            timeControl.setValue(moment(value).format(this.timeFormat));
            timePickerControl.setValue(moment(value));
          }
        }
      }
    });
    this.SDKSubs$ = [formValueChangeForSDKEmit$, formPatchSub$];
    this._utilityService.castModalEventToSdk('open', {
      id: 'job_reschedule',
      job_details: {
        ...this.jobDetails,
        dispatch_details: this.dialogData?.data?.dispatchDetails ?? null,
      }
    });
  }

}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function endTimeMinValidator(checkRouteMaxDuration: boolean = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const startTime = control.parent?.value.startTimePicker;
    const endTime = control.parent?.value.endTimePicker;
    const startDate = control.parent?.value.startDate;
    const endDate = control.parent?.value.endDate;
    const  validationResult: any = {};
    let isRouteDurationExceed =false;;

    if (!startTime || !endTime || !startDate || !endDate) {
      return null;
    }
    const startTimeObject = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
    const endTimeObject = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
    if(checkRouteMaxDuration) {
      isRouteDurationExceed = endTimeObject.diff(startTimeObject, 'm') > 1440;
      if(isRouteDurationExceed) {
        validationResult['routeMaxDurationError'] = true;
      }
      else {
        delete validationResult['routeMaxDurationError'];
      }
    }
    const invalidEndTime = endTimeObject.isSameOrBefore(startTimeObject);
    if(invalidEndTime) {
      validationResult['invalidEndTime'] = true;
    }
    else{
      delete validationResult['invalidEndTime'];
    }
    return invalidEndTime || isRouteDurationExceed ? validationResult : null;
  };
}
